import { ApiBind } from "@app/core/models/common.model";
import { Parameter } from "@app/core/models/parameter.model";

/**
 * 広告リクエストの初期パラメータを表すモデル
 *
 * @exports
 */
export class AdRequestDefaultParameter extends Parameter {
    @ApiBind({column: 'id'})
    id: number;

    @ApiBind({column: 'delivery_type'})
    deliveryType: number;
}
